import React from 'react';
// import './PriorityPayment.css';
import AddCardService from '../../Services/AddCardService';
import { ShowAlert } from '../../Component/ShowAlert';
import { ShowBlocker } from '../../Component/LoaderComponent';
// import { creditCardType } from 'credit-card-type';
var creditCardType = require("credit-card-type");

enum WidgetType {
    VAULT = "VAULT",
    CHECKOUT = "CHECKOUT",
}

interface PriorityPaymentProps { }
interface PriorityPaymentState {
    clientSecret: string;
    profile: any;
    accessToken: any;
    widgetType: any
}

class PriorityPayment extends React.Component<PriorityPaymentProps, PriorityPaymentState> {

    private widget: any = null;

    constructor(props_: PriorityPaymentProps) {
        super(props_);

        this.widget = null;

        this.state = {
            clientSecret: "",
            profile: {},
            accessToken: "",
            widgetType: WidgetType.VAULT
        }
    }


    componentDidMount() {
        const { clientSecret } = this.state;

        this.getUserDetails();
    }

    componentWillUnmount() {
        // Cleanup widget if SDK provides destroy/unmount method
        if (this.widget && typeof this.widget.destroy === "function") {
            this.widget.destroy();
        }
    }

    public render() {
        return (
            <div id="checkout-container"></div>
        )
    }

    private getUserDetails() {
        const queryString = new URLSearchParams(window.location.search);
        console.log(process.env.REACT_APP_API_URL);
        let code = queryString.get("token");

        if (code) {
            AddCardService.getUserDetails(code).then(r => {
                if (r.ok) {
                    r.json().then(resp => {
                        this.setState({
                            profile: resp,
                            accessToken: code
                        }, () => {
                            this.getAccessToken();
                        });
                    });
                }
            });
        }
    }

    getAccessToken() {
        let reqToken = {
            "widgetType": this.state.widgetType,
        };

        AddCardService.getPceAccesstoken(this.state.accessToken, reqToken).then(r => {
            if (r.ok) {
                r.json().then(resp => {
                    console.log(resp.clientSecret, this.state.profile.userId);
                    console.log(this.state.widgetType == WidgetType.VAULT, this.state.widgetType)
                    if (this.state.widgetType == WidgetType.VAULT) {
                        this.widget = window.WidgetSDK.create('VAULT', {
                            clientSecret: resp.clientSecret, // From your backend
                            containerId: '#checkout-container', // From your div ID
                            businessId: "979bdb82-f1ce-5028-8fed-e020625d2797",

                            customer: {
                                id: "10000001679411" //this.state.profile.userId // 4886731 // returning customer
                            },
                            payementMethods: {
                                card: {
                                    enabled: true,
                                    showSaved: true
                                },
                                bankAccount: {
                                    enabled: true,
                                    showSaved: true
                                }
                            },

                            debug: true,

                            consentMode: 'ECOM',

                            onSuccess: (result: any) => {
                                console.log('Vault successful:', result.data.card.id);
                                window.location.href = '/order/success';
                            },

                            onError: (error: any) => {
                                console.error('Vault error:', error.message);
                            }
                        });
                    }
                    else {
                        this.widget = window.WidgetSDK.create("CHECKOUT", {
                            clientSecret: resp.clientSecret, // From your backend
                            containerId: "#checkout-container", // Matches the div below
                            businessId: "979bdb82-f1ce-5028-8fed-e020625d2797",
                            transactionOrigin: "CARD_PRESENT_KEYED",

                            amount: {
                                value: "50.00",
                                currency: "USD",
                            },

                            onSuccess: (result: any) => {
                                console.log("Payment successful:", result.transactionId);

                                window.location.href = "/order/success";
                            },

                            onComplete: (result: any) => {
                                // Optional cleanup or analytics
                                console.log("Checkout completed:", result);
                            },

                            onError: (error: any) => {
                                console.error("Payment error:", error.message);
                            },
                        });
                    }
                });
            }
        });
    }
}

export default PriorityPayment;